"use client";

import { useActionState } from "react";
import { requestResetAction, type RequestResetState } from "./actions";

const initialState: RequestResetState = {};

export function RequestResetForm() {
  const [state, formAction, pending] = useActionState(requestResetAction, initialState);

  if (state.sent) {
    return (
      <p className="mt-6 rounded-lg bg-green-50 px-3 py-2 text-sm text-green-700">
        Se o e-mail informado existir em nossa base, voce recebera um link para redefinir a senha.
      </p>
    );
  }

  return (
    <form action={formAction} className="mt-6 flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <label htmlFor="email" className="text-sm font-medium text-[#1A1A1A]">
          E-mail
        </label>
        <input
          id="email"
          name="email"
          type="email"
          required
          autoComplete="email"
          className="rounded-lg border border-[#E4E7EC] bg-white px-3 py-2 text-sm outline-none focus:border-[#9429A7] focus:ring-1 focus:ring-[#9429A7]"
        />
      </div>

      {state.error && (
        <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{state.error}</p>
      )}

      <button
        type="submit"
        disabled={pending}
        className="mt-2 rounded-lg bg-[#9429A7] px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-[#7d2390] disabled:opacity-60"
      >
        {pending ? "Enviando..." : "Enviar link de redefinicao"}
      </button>
    </form>
  );
}
